import "vite/modulepreload-polyfill";

import swup from "./swup";

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect"; 

import { store as cart } from "@/stores/cart";  
import { store as popup } from "@/stores/popup";
import { store as productModal } from "@/stores/productModal";
import { store as consent } from "@/stores/consent";
import { store as sticky } from "@/stores/sticky";

import Carousel from "@/components/carousel";
import CartItem from "@/components/cart-item";
import Marquee from "@/components/marquee";
import ProductForm from "@/components/product-form";
import ProductCardForm from "@/components/product-card-form";
import SlideDot from "@/components/slide-dot";
import StickyCardScroll from "@/components/sticky-card-scroll";
import StickyScroll from "@/components/sticky-scroll";
import Newsletter from "@/components/newsletter";
import Video from "@/components/video";
import ProductWaitlist from "@/components/product-waitlist";
import Navigation from "@/components/navigation";
import giftWithPurchase from "@/components/gift-with-purchase";
import { money } from "@/utils";

Alpine.directive("money", (el, { expression }, { evaluateLater, effect }) => {
  let setMoney = evaluateLater(expression);

  effect(() => {
    setMoney((price) => (el.innerHTML = money(price)));
  });
});

Alpine.plugin(intersect);
Alpine.plugin(focus);
Alpine.plugin(collapse); 

Alpine.store("consent", consent);
Alpine.store("cart", cart);  
Alpine.store("popup", popup);
Alpine.store("productModal", productModal);
Alpine.store("sticky", sticky);

Alpine.data("navigation", Navigation);
Alpine.data("slideDot", SlideDot);
Alpine.data("stickyScroll", StickyScroll);
Alpine.data("stickyCardScroll", StickyCardScroll);
Alpine.data("carousel", Carousel);
Alpine.data("marquee", Marquee);
Alpine.data("cartItem", CartItem);
Alpine.data("productForm", ProductForm);
Alpine.data("productCardForm", ProductCardForm);
Alpine.data("newsletter", Newsletter);
Alpine.data("productWaitlist", ProductWaitlist);
Alpine.data("video", Video);

window.Alpine = Alpine;

swup.hooks.on("visit:start", (event) => {
  console.log("visit start: ", event);
});

swup.hooks.on("page:view", (event) => {
  console.log("page:view: ", event);

  const videos = document.querySelectorAll("video");
  if (!videos) return;
  console.log("videos: ", videos);
  videos.forEach((video) => {
    video.load();
  });
}); 

Alpine.start();
